import { useEffect, useState} from 'react';

import axios from 'axios';

const useFetchData = ({vid, setLoading}) => {
  const [data, setData] = useState({});
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const { data: response } = await axios.get(`https://bulkify.in/api/vendor/bank-detail.php?vid=${vid}`);
        setData(response);
      } catch (error) {
        console.error(error)
      }
      finally{
        setLoading(false);
      }
      
    };

    fetchData();
  }, [vid, setLoading]);

  return {data};
};

export default useFetchData;